// extracted by mini-css-extract-plugin
export default {"socials":"org_info_list__socials--eeUp","social":"org_info_list__social--DGgy","socialLink":"org_info_list__socialLink--t3vH"};